import { action } from '@ember/object';
import Component from '@glimmer/component';
import Highcharts from 'highcharts';

/*
  attrs
  - percent
  - secondaryPercent
    - optional
    - will be lighter color than regular percent unless secondaryColor is filled out
  - color - 'blue' or 'orange'
  - secondaryColor - 'blue' or 'orange'
  - innerSize - include % like '55%'
  - size - in pixels
*/
export default class DonutChartComponent extends Component {
  get percent() {
    return this.args.percent || 0;
  }

  get secondaryPercent() {
    return this.args.secondaryPercent || 0;
  }

  get color() {
    return this.args.color || 'blue';
  }

  get colorCode() {
    if (this.color === 'orange') {
      return '#f0ad4e';
    } else {
      return '#0b68a1';
    }
  }

  get secondaryColorCode() {
    if (this.args.secondaryColor) {
      if (this.args.secondaryColor === 'orange') {
        return '#f0ad4e';
      } else {
        return '#0b68a1';
      }
    } else {
      if (this.color === 'orange') {
        return '#eacba0';
      } else {
        return '#8ac7ec';
      }
    }
  }

  get size() {
    return this.args.size || 40;
  }

  fontFamily =
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

  get chartSettings() {
    let { percent, secondaryPercent } = this;

    if (percent > 100) {
      percent = 100;
    }
    if (percent + secondaryPercent > 100) {
      secondaryPercent = 100 - percent;
    }
    let fillerPercent = 100 - percent - secondaryPercent;

    return {
      chart: {
        type: 'pie',
        spacing: [0, 0, 0, 0],
        animation: false,
        height: this.size,
        width: this.size,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ['50%', '50%'],
        },
        series: {
          animation: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      series: [
        {
          size: '100%',
          innerSize: this.args.innerSize,
          dataLabels: {
            enabled: false,
          },
          data: [
            {
              y: percent,
              color: this.colorCode,
            },
            {
              y: secondaryPercent,
              color: this.secondaryColorCode,
            },
            {
              y: fillerPercent,
              color: '#eceeef',
            },
          ],
        },
      ],
    };
  }

  @action
  renderChart(el) {
    Highcharts.chart(el, this.chartSettings);
  }
}
